import React from 'react';
import { Helmet } from 'react-helmet';
import './Blog.css';

function Blog() {
  const blogPosts = [
    {
      id: 1,
      title: 'El Arte del Beneficiado de la Vainilla: Un Proceso Delicado',
      summary: 'Descubre los meticulosos pasos involucrados en el beneficiado artesanal y tradicional de las vainas de vainilla para alcanzar la concentración óptima de vainillina y aroma.',
      date: '26 de octubre de 2024',
      image: '/field1.jpeg',
      tag: 'Procesamiento',
    },
    {
      id: 2,
      title: 'La Vainilla en la Agricultura Sostenible y Agroforestal',
      summary: 'Explora cómo el cultivo de vainilla bajo sombra regulada y tutores vivos enriquece la biodiversidad, regenera el suelo y maximiza la rentabilidad del productor.',
      date: '10 de noviembre de 2024',
      image: '/field2.jpeg',
      tag: 'Agricultura',
    },
    {
      id: 3,
      title: 'La Ciencia Detrás de las Propiedades Antioxidantes de la Vainilla',
      summary: 'Análisis biotecnológico de los compuestos fenólicos y polifenoles presentes en Vanilla planifolia y su impacto en la salud y alta gastronomía.',
      date: '20 de noviembre de 2024',
      image: '/field3.jpeg',
      tag: 'Biotecnología',
    },
  ];

  return (
    <div className="blog-page">
      <Helmet>
        <title>Blog y Aventuras Vainilleras | Sol de Vainilla</title>
        <meta
          name="description"
          content="Artículos técnicos, bitácoras de campo y avances en biotecnología y cultivo de vainilla en Costa Rica y Mesoamérica."
        />
      </Helmet>

      {/* Hero Header */}
      <section
        className="blog-hero"
        style={{
          backgroundImage:
            "radial-gradient(circle at center, rgba(14, 25, 12, 0.65) 0%, rgba(10, 18, 9, 0.9) 100%), url('/field3.jpeg')",
        }}
      >
        <div className="container">
          <span className="blog-badge">Bitácora de Campo y Ciencia</span>
          <h1>Aventuras Vainilleras</h1>
          <p>
            Crónicas, investigaciones y experiencias técnicas directamente desde las plantaciones y laboratorios de vainilla en Mesoamérica.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="blog-main-section">
        <div className="container">
          {/* Featured Article Card */}
          <div className="featured-blog-card">
            <div className="featured-blog-image">
              <img src="/field4.jpeg" alt="Plantaciones de Vainilla en Escuintla Guatemala" />
              <span className="featured-tag">Crónica de Viaje</span>
            </div>
            <div className="featured-blog-content">
              <span className="post-date-tag">Publicado: 24 de Abril de 2025</span>
              <h2>Explorando las Plantaciones de Vainilla en Escuintla, Guatemala</h2>
              <div className="featured-text">
                <p>
                  En esta expedición técnica a la región de Escuintla, Guatemala, recorremos plantaciones establecidas en suelos volcánicos fértiles y microclimas ideales para la <em>Vanilla planifolia</em>.
                </p>
                <p>
                  Compartimos aprendizajes de primera mano sobre las técnicas locales, polinización manual, manejo de sombra y el delicado proceso de beneficiado que transforma las vainas verdes en un tesoro aromático de calidad de exportación.
                </p>
              </div>
            </div>
          </div>

          {/* Grid Section */}
          <div className="blog-articles-heading">
            <span className="section-kicker">ARTÍCULOS Y PUBLICACIONES</span>
            <h3>Últimas Investigaciones</h3>
          </div>

          <div className="blog-grid">
            {blogPosts.map((post) => (
              <div className="blog-post-card" key={post.id}>
                <div className="post-image-box">
                  <img src={post.image} alt={post.title} />
                  <span className="post-category-tag">{post.tag}</span>
                </div>
                <div className="post-content">
                  <span className="post-date">{post.date}</span>
                  <h4 className="post-title">{post.title}</h4>
                  <p className="post-summary">{post.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Blog;